import { render, staticRenderFns } from "./AdminPayrollLayout.vue?vue&type=template&id=b44dd12e&scoped=true&"
import script from "./AdminPayrollLayout.vue?vue&type=script&lang=ts&"
export * from "./AdminPayrollLayout.vue?vue&type=script&lang=ts&"
import style0 from "./AdminPayrollLayout.vue?vue&type=style&index=0&id=b44dd12e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b44dd12e",
  null
  
)

export default component.exports